import { z } from "zod";

export const ExperienceActionTypeList = [
  "start",
  "pause",
  "end",
  "delete",
] as const;
export type ExperienceActionType = (typeof ExperienceActionTypeList)[number];

export const ExperienceActionDtoSchema = z.object({
  id: z.string().uuid(),
  experienceId: z.string().uuid(),
  action: z.enum(ExperienceActionTypeList),
  actionTs: z.number(),
});

export type ExperienceActionDto = z.infer<typeof ExperienceActionDtoSchema>;
